<template>
  <div>
    <legend>{{ legend }}
      <a @click="$emit('close')" href="#" class="btn pull-right closeWindow">
        <i class="fas fa-times fa-2x"></i>
      </a>
    </legend>
    <form>
      <calActivity ref="calActi" :activities="activities" v-model="booking.activities"></calActivity>
      <calProviders :errors="errors" :isEdited="isEdited" :current="current" :users="users" :renforts="renforts" :calendarResources="calendarResources" :quickCreate="quickCreate" name="user_id" @input="validate"></calProviders>

      <div class="form-group" hidden>
        <label for="title">Titre *</label>
        <input type="text" class="form-control" id="title" name="title" required placeholder="Titre"  v-model="booking.title">
      </div>
      <div class="row">
        <v-date :errors="errors" name="start" title="Date de début *" format="YYYY-MM-DD HH:mm:ss" v-model="booking.eventStart" v-validate="'required'" data-vv-name="Date de début"></v-date>
        <v-date :errors="errors" name="end" title="Date de fin *" format="YYYY-MM-DD HH:mm:ss" v-model="booking.eventEnd" v-validate="'required'" data-vv-name="Date de fin" ></v-date>
      </div>
      <v-input :errors="errors" type="text" name="rdv" title="Lieu de RDV" v-model="booking.rdv"></v-input>
      <customer-select v-model="booking.selectedCustomer" @input="checkCustomer"></customer-select>

      <div class="row">
        <div class="form-group col-sm-6">
          <!--        register user payment card          -->
          <div class="content" v-show="showAddCardButton">
            <a class="btn btn-right blue" @click="togglePaymentCardModal()">{{addCardText}}</a>
          </div>
          <register-payment-card ref="registerCardElRef" :show-card-modal="showCardModal" :booking-selected-customer="booking.selectedCustomer"></register-payment-card>
          <!--        End register user payment card      -->
        </div>
        <div class="col-sm-6">
          <!--        send payment mail                   -->
          <div class="content" v-show="showSendPaymentMailButton">
            <a class="btn btn-right blue" @click="showSendPaymentMailModal=true">{{(booking.published_at?'Renvoyer':'Envoyer')+' un lien de paiement'}}</a>
          </div>
          <send-payment-link :booking="booking" :show.sync="showSendPaymentMailModal"></send-payment-link>
          <div class="content" v-show="isPaymentDone">
            Lien de paiement déja payé
          </div>
          <div class="content" v-show="showMissingStripeError">
            Veuillez renseigner votre compte stripe dans l'onglet "Configuration/Structure/Stripe"
          </div>
          <!--        End send payment mail               -->
        </div>
      </div>

      <v-ckeditor name="remarques" title="Remarques" v-model="booking.comments"></v-ckeditor>
      <div class="form-group">
        <label>Modalité de paiement:</label>
        <div class="form-inline">
          <select class="form-control input-medium" name="typePaiement" v-model="booking.payment">
            <option  v-for="payment in payments" :value="payment" :key="payment.index">{{ payment }}</option>
          </select>
          <select class="form-control input-medium" name="statusPaiement" v-model="booking.isPaid">
            <option :value="true">Payé</option>
            <option :value="false">Non payé</option>
          </select>
          <i v-if="booking.isPaid" class="far fa-smile fa-lg" style="color: green; margin-left: 1rem"></i>
          <i v-else class="far fa-frown fa-lg" style="color: red; margin-left: 1rem"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="form__label">
          <label>Choisissez une couleur *: </label>
        </div>
        <div class="form__input">
          <swatches v-model="color" inline @input="validate"></swatches>
        </div>
      </div>
      <div class="alert alert-danger" v-show="customErrorMessage.error === true && ferrors.all().length>0 || customErrors.length>0">
        <h3>{{customErrorMessage.message}}</h3><hr>
        <ul>
          <li v-for="error in ferrors.all()" :key="error.id">{{ error }}</li>
          <li v-for="(cerror,idx) in customErrors" :key="idx">{{cerror}}</li>
        </ul>
      </div>
    </form>
    <button @click.prevent="addbooking()" class="btn btn-block green" >{{isEdited && !quickCreate ? 'Sauvegarder': 'Créer'}}</button>
    <a :class="{'generateBillDisable' : booking.has_billing }" v-show="isEdited && !quickCreate" @click="addbooking(false,false)" :href="redirectbillingroute.toString()+'/create?bid='+this.booking.id" class="btn blue btn-block btn-right" :disabled="booking.has_billing">{{this.booking.has_billing ? 'Facture déja générée' :'Génerer facture'}} </a>
    <button class="btn blue btn-block btn-right" v-show="isEdited && !quickCreate" @click.prevent="addbooking(true)">Dupliquer</button>
    <button v-show="isEdited && !quickCreate" @click.prevent="delEvent" class="btn btn-block btn-right btn-danger">Supprimer</button>
  </div>
</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import SendPaymentLink from "../../order/sendPaymentLink"
export default {
  name: 'calBooking',
  props: ['legend', 'users', 'activities', 'customers', 'booking', 'current', 'renforts', 'quickCreate', 'redirectbillingroute', 'calendarResources','userType', 'permissions','hasStripe'],
  components: {
      SendPaymentLink,
      Swatches,
      VueCtkDateTimePicker,
      'v-select-lib': vSelect
    },
  data() {
    return {
      showCardModal: false,
      showAddCardButton: false,
      color: this.current.color,
      isEdited:!!this.booking.id,
      errors: {},
      payments: ['','Chèque ou Virement','Chèque', 'Espèce', 'Virement', 'CB', 'CB en ligne', 'Offert', 'Chèque vacances', 'Bon cadeau', 'Autre'],
      vselectErrors:'Tapez au moins 3 lettres pour rechercher un client',
      customErrors: [],
      customErrorMessage:{ error: false, message: ''},
      addCardText:'Ajouter CB',
      showSendPaymentMailButton : false,
      showMissingStripeError: false,
      showSendPaymentMailModal : false
    }
  },
  created(){
    this.$validator.extend('colorFormat',
    {
        getMessage: field =>'ErrorMsg',
        validate:(value) =>
        {
            var regex = RegExp('/^#([0-9a-f]{3}){1,2}$/i')
            return regex.test(value)
        }
    })
    if(!this.isEdited)
    {
      this.booking.activity = null
      this.booking.activities = null
    }

    //show/hide add payment card button
    this.showAddPaymentCardButton()
    //show/hide payment link mail button
    this.showSendPaymentMail()
  },
  computed: {
    isPaymentDone: function(){
      if(this.booking.booking_invitations && this.booking.booking_invitations.length){
        return this.booking.booking_invitations.reduce((acc,item)=>{return acc||item.order!==null},false)
      }
      return false
    },
  },
  methods: {
    togglePaymentCardModal() {
      if(this.booking.selectedCustomer.id){
        this.showCardModal = !this.showCardModal
      }
    },
    showAddPaymentCardButton(){
      if(this.booking.selectedCustomer.id &&  this.permissions.includes('module-cb')){
        this.showAddCardButton = true
        //if card exist set button label to card last4 number
        if( this.booking.selectedCustomer.card_last_four){
          this.addCardText = '**** '+this.booking.selectedCustomer.card_last_four
        }else{
          this.addCardText = 'Ajouter CB'
        }
      }
    },
    //SetLast4 to replace add card button text
    setLast4(last4){
      this.addCardText = '**** '+last4
    },
    setTitle() {
      if(this.booking.activities){
        this.booking.title="";
        this.booking.activities.forEach(selected => {
          this.booking.title+=(this.booking.title?", ":"")+this.activities.filter(acti=>acti.id===selected.id)[0].name+" (x"+selected.qty+")"
        });
      }
    },
    showSendPaymentMail(){
      if(this.booking.id && this.booking.selectedCustomer.id && this.permissions.includes('module-paiement') && !this.isPaymentDone) {
        if(this.hasStripe){
          this.showSendPaymentMailButton = true
        }else{
          this.showMissingStripeError = true
        }
      }
    },

    async addbooking(duplicate=false,shouldClose=true) {
      this.booking.activities=this.$refs.calActi.getActivities()
      if(await this.validate())
      {
  			const newBooking = {
          //activity_id: this.booking.activity,
          activities: this.booking.activities,
          user_id: this.current.userId,
          renfort_id: this.current.renfortId,
          calendar_resource_id: this.current.calendar_resourceId,
  	      group_count: 1,
          message: this.booking.comments,
          customer_id: this.booking.selectedCustomer.id,
          title: this.booking.title,
          meeting_point: this.booking.rdv,
          start: this.booking.eventStart,
          end: this.booking.eventEnd,
          color : this.color,
          event_id: this.booking.eventId,
          activity_id: this.booking.activity,
          booking_id: Object.keys(this.booking).length === 0 ? null : this.booking.id,
          is_paid: this.booking.isPaid,
          payment_method: this.booking.payment,
        }

        let met = 'post'
        let route = 'calendar/event/booking'
        if(this.isEdited){
          met = 'put'
          route += '/' + this.booking.eventId
        }
        axios[met](route, newBooking).then(response => {
          if(!duplicate){
            if(shouldClose){
              this.$emit('close')
              this.$emit('refetch-events')
              this.$emit('snotify')
            }
          }else{this.duplicate()}
        })
      }
    },
    duplicate(){
      this.$emit('refetch-events')//refresh calendar
      this.isEdited=false;
      this.booking.comments = ''
      $("html, body").animate({scrollTop: 0}, 'fast');
    },
    delEvent(event) {
      let confirmConfig={
        title:'Êtes-vous sûr de vouloir supprimer ?',
        btnOkLabel:'<i class="icon-ok-sign icon-white"></i> Oui',
        btnCancelLabel:'<i class="icon-remove-sign"></i> Non',
        btnOkClass:"btn green",
        btnCancelClass:"btn btn-danger",
        placement:'bottom',
        onConfirm:(event,element)=>{
          event.preventDefault()//prevent scroll top
          axios.delete('calendar/event/' + this.booking.eventId)
            .then(response =>{
              this.$emit('refetch-events')
              this.$emit('snotify')
              this.$emit('close')
            })
            .catch((error)=>{
              if (error.response) {
                this.$snotify.error(error.response.data.message)
              }else{
                this.$snotify.error(error.message)
              }
            })
        }
      };
      $(event.target).confirmation(confirmConfig);
      $(event.target).confirmation('show');
    },
    async setCustomer(value) {
      this.booking.selectedCustomer = value
      this.validate()
      this.showAddPaymentCardButton()
    },
    async checkCustomer(event)
    {
      if(event==null){
        this.validate('dismiss')
      }else{
        this.validate('added')
        this.showAddPaymentCardButton()
      }
    },
    async validate(customerSelectEvent = null){
      let regex = RegExp('^#([0-9a-f]{3}){1,2}$','i')
      let err = 0
      this.customErrors = []

      if(this.current.userId=="" && this.current.renfortId=="" && this.current.calendar_resourceId==""){
        err+=1
        this.customErrors.push("Veuillez sélectionner un prestataire ou un renfort")
      }
      //event===null when dismiss from select
      if(customerSelectEvent==='dismiss' || (customerSelectEvent==null && ( !this.booking.selectedCustomer || Object.keys(this.booking.selectedCustomer).length === 0))){
        err+=1
        this.customErrors.push("Veuillez choisir ou créer un client")
      }
      if(!regex.test(this.color)){
        err+=1
        this.customErrors.push('Veuillez choisir une couleur pour cette réservation')
      }
      await this.$validator.validateAll().then((result) =>{
        if (!result) {
          err+=this.ferrors.all().length
        }
      });
      if(!this.booking.activities){
        err++;
      }else{
        this.setTitle()
      }
      if(err>0){
        let msg = (err>1) ? 'Erreurs lors de la validation :' : 'Erreur lors de la validation :'
        this.customErrorMessage = {
          error : true,
          message : msg
        }
        return false
      }
      return true
    },
  },
};
</script>
<style scoped>
.no-padding-h {
  padding-right: 0;
  padding-left: 0;
}
.content {
  display: flex;
  justify-content: space-around;
}
.mt-checkbox-inline {
  padding: 10px 0 0!important;
}
.modalContent {
  padding: 2rem;
}
.time-picker-column-item.active {
 background-color: #FFFFFF!important;
}
.time-picker-column-item.active:hover {
  background-color: #FFFFFF!important;
}
.field-input {
  border-color: #c2cad8!important;
}
.generateBillDisable {
  pointer-events: none;
}
.sm-spacing{
  padding-left: 0px;
}
@media (max-width: 768px) {
  .sm-spacing{
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
